// @flow

import { dateIsBetween } from 'client/utils/validate';
/* eslint-disable no-confusing-arrow */

export const getLadderFormattedGender = (gender: 'M' | 'F' | null) => {
  if (gender) {
    return gender === 'M' ? 'male' : 'female';
  }

  return '';
};

export const getStringFromBoolean = (boolean: boolean) => (boolean === true ? 'true' : 'false');

// Ladder API returns plans for users between age 20 and 60
export const getAgeValidator = () => {
  const min = 20;
  const max = 60;

  return (val: string) =>
    dateIsBetween(max, min)(val) && {
      path: 'common.error.ageOutOfBounds',
      using: { min, max },
    };
};

export const isValidAge = (dob: string) => {
  const min = 18;
  const max = 75;
  // If dateIsBetween returns undefined it means that the date is not above the
  // max or below the min. It's a bit of an ugly hack using an existing function
  return dob.length === 10 && dateIsBetween(max, min)(dob) == null;
};

// Inserts userId into URL returned by Ethos quote API for tracking purposes
// Example: https://stridehealth.getethos.com/term?birthday=1991-01-02&coverage=1000000&smoker=false&gender=Female&term=20&health=2&trackingId=6843aa5d-81e1-4323-972d-cf4db340c6c6
export const getFormattedEthosUrl = (userId: string, url: string) =>
  userId ? url.concat(`&trackingId=${userId}`) : url;
